import './PasswordField.css';

import FormErrorMessage from 'components/FormErrorMessage';
import { FormInput } from 'components/FormInput/FormInput';
import get from 'lodash/get';

const PasswordField = ({
  autoFocus,
  block,
  disabled,
  disableErrorMessage,
  input,
  // alias for placeholder. Keeping just to avoid refactoring of untyped code, redux form is deprecated in our codebase.
  label,
  id,
  msg,
  meta: { touched, error },
  className,
  placeholder,
  spaceRight,
  spaceTop,
  style,
}) => (
  <div className={block ? 'block' : 'inline-block'}>
    <FormInput
      {...input}
      autoComplete='off'
      autoFocus={autoFocus}
      disabled={disabled}
      id={id}
      className={className}
      hasError={touched && error}
      placeholder={label ?? placeholder}
      type='password'
      spaceTop={spaceTop}
      spaceRight={spaceRight}
      style={style}
    />
    {touched && !disableErrorMessage && error && (
      <FormErrorMessage>
        {get(msg, ['validation', error], error)}
      </FormErrorMessage>
    )}
  </div>
);

export default PasswordField;
